/**
 * API Endpoint definitions and Base URL configuration.
 */

export const APIEndpoints = {
  LoginUsingEmail: "/crm/login",
  GetProfile: "/crm/profile",
  GetStudents: "/crm/coql",
  CreateAttendance: "/crm/attendance/create",
  SearchAttendance: "/crm/coql",
  CreateClassContent: "/crm/create",
  EditClassContent: "/crm/edit",
  SearchClassContent: "/crm/coql",
  GetClassContentById: "/crm/get",
  GetPreviewLink: "/workdrive/preview-link",
  GetDownloadLink: "/workdrive/download-folder",
  GetChatInbox: "/chat/inbox",
  GetChatMessages: "/chat/messages",
  SendChatMessage: "/chat/send",
  MarkMessagesRead: "/chat/mark-read",
  GetUnreadChatCount: "/chat/unread-count",
  SubmitArtwork: "/workdrive/assignments/submit",
  GetTeacherSubmittedArtworks: "/crm/coql",
  MarkArtwork: "/crm/edit",
  CreateAnnouncement: "/crm/create",
  EditAnnouncement: "/crm/edit",
  SearchAnnouncements: "/crm/coql",
} as const;

export const BASE_URL: string = "https://aksharart-api.bapsanz.org.au";
